import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

import { CORE_ASSET_FIELDS } from 'app/src/components/Assets/queries';

const ERRORS = `errors { path, message }`;

const EXPENSE_FIELDS = `
  id
  vendor { id, name }
  requestedBy { id, firstName, lastName }
  invoiceNumber
  description
  status
  paymentMethod
  paymentReference
  clearedOn
  total
  expenseLines {
    id
    asset {
      id,
      name,
      vin,
      stockNumber
      seller { name }
    }
    saleAsset {
      id
      lotNumber
      correctedLotNumber
      sale { id , name, saleOn }
    }
    amount
    description
  }
  expenseFiles { id, filename, contentType, url}
  linkedAttachments { id, name, url, resourceId, resourceType }
`

const EXPENSE_VARIABLES = `
  $vendorId: ID!
  $requestedById: ID
  $invoiceNumber: String
  $description: String
  $paymentMethod: String
  $paymentReference: String
`;

const EXPENSE_ARGUMENTS = `
  vendorId: $vendorId
  requestedById: $requestedById
  invoiceNumber: $invoiceNumber
  description: $description
  paymentMethod: $paymentMethod
  paymentReference: $paymentReference
`;

const EXPENSE_FIELDS_AND_ERRORS = `
  expense {
    ${EXPENSE_FIELDS}
  }
  ${ERRORS}
`;

export const EXPENSES_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
    $assetId: ID
  ) {
    expensesWithCount(
      ${WITH_COUNT_ARGUMENTS}
      assetId: $assetId
    ) {
      entries {
        ${EXPENSE_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_EXPENSE = gql`
  mutation CreateExpense(
    ${EXPENSE_VARIABLES}
    $newPurchaseOrder: Boolean
    $expenseFiles: [Upload!]
    $linkedAttachmentAttributes: [LinkedAttachmentInput!]
    $clearedOn: ISO8601Date
    $markAsPaid: Boolean
  ) {
    createExpense(
      ${EXPENSE_ARGUMENTS}
      newPurchaseOrder: $newPurchaseOrder
      expenseFiles: $expenseFiles
      linkedAttachmentAttributes: $linkedAttachmentAttributes
      markAsPaid: $markAsPaid
      clearedOn: $clearedOn
    ) {
      expense { ${EXPENSE_FIELDS} }
      errors { path, message }
    }
  }
`;

export const UPDATE_EXPENSE = gql`
  mutation UpdateExpense(
    $id: ID!
    $expenseFiles: [Upload!]
    $linkedAttachmentAttributes: [LinkedAttachmentInput!]
    $markAsPaid: Boolean
    $clearedOn: ISO8601Date
    ${EXPENSE_VARIABLES}
  ) {
    updateExpense(
      id: $id
      expenseFiles: $expenseFiles
      linkedAttachmentAttributes: $linkedAttachmentAttributes
      markAsPaid: $markAsPaid
      clearedOn: $clearedOn
      ${EXPENSE_ARGUMENTS}
    ) {
      ${EXPENSE_FIELDS_AND_ERRORS}
    }
  }
`;

export const EXPENSE = gql`
  query Expense($id: ID!) {
    expense(id: $id) {
      ${EXPENSE_FIELDS}
      expenseDeltas {
        id
        userDescription
        createdAt
        resourceType
        resourceId
        expenseDescription
        fields {
          name
          oldValue
          newValue
        }
      }
    }
  }
`;

export const HIDE_EXPENSE = gql`
  mutation HideExpense($id: ID!) {
    hideExpense(id: $id) {
      expense {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const SELECTS = gql`
  query SelectOptions {
    assets {
      ${CORE_ASSET_FIELDS}
      seller { id, name }
    }
    saleAssets {
      id
      sale { id, name }
      status
      lotNumber
      correctedLotNumber
    }
  }
`



